import { ActionReducer, Action } from "@ngrx/store";
import { TutorAllocationsStore } from "@store/tutor-allocations";
import { TutorAllocation } from "@models/tutor-allocation";

export const tutorAllocationsReducer: ActionReducer<TutorAllocationsStore> = (state: TutorAllocationsStore = new TutorAllocationsStore(), action: Action) => {

  switch(action.type) {
    case POPULATE_TUTOR_ALLOCATIONS:
      return new TutorAllocationsStore(
        [...action.payload],
        state.activeTutorAllocation)

    case POPULATE_EDITABLE_TUTOR_ALLOCATION:
      return new TutorAllocationsStore(
        [...state.tutorAllocations],
        action.payload)

    case ADD_TUTOR_ALLOCATION:
      return new TutorAllocationsStore(
        [action.payload, ...state.tutorAllocations],
        state.activeTutorAllocation)

    case REPLACE_TUTOR_ALLOCATION:
      const p: TutorAllocation = action.payload
      const tas = state.tutorAllocations.map((ta: TutorAllocation) => {
        if (ta.id == p.id) { return p }
        return ta
      })

      const activeTa = p.id == state.activeTutorAllocation.id ?
        p : state.activeTutorAllocation

      return new TutorAllocationsStore(tas, activeTa)

    default:
      return state

  }
}

export const FETCH_TUTOR_ALLOCATIONS = "FETCH_TUTOR_ALLOCATIONS"
export const FETCH_TUTOR_ALLOCATIONS_FAILURE = "FETCH_TUTOR_ALLOCATIONS_FAILURE"
export const POPULATE_TUTOR_ALLOCATIONS = "POPULATE_TUTOR_ALLOCATIONS"
export const POPULATE_EDITABLE_TUTOR_ALLOCATION = "POPULATE_EDITABLE_TUTOR_ALLOCATION"
export const CREATE_TUTOR_ALLOCATION = "CREATE_TUTOR_ALLOCATION"
export const CREATE_TUTOR_ALLOCATION_FAILURE = "CREATE_TUTOR_ALLOCATION_FAILURE"
export const ADD_TUTOR_ALLOCATION = "ADD_TUTOR_ALLOCATION"
export const UPDATE_TUTOR_ALLOCATION = "UPDATE_TUTOR_ALLOCATION"
export const UPDATE_TUTOR_ALLOCATION_FAILURE = "UPDATE_TUTOR_ALLOCATION_FAILURE"
export const REPLACE_TUTOR_ALLOCATION = "REPLACE_TUTOR_ALLOCATION"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/tutor-allocations.ts